import { render, staticRenderFns } from "./attachment-list.vue?vue&type=template&id=55038f4f&scoped=true&"
import script from "./attachment-list.vue?vue&type=script&lang=js&"
export * from "./attachment-list.vue?vue&type=script&lang=js&"
import style0 from "./attachment-list.vue?vue&type=style&index=0&id=55038f4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55038f4f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
